import { CSSProperties, ReactNode } from 'react';

import {
  footerStyle,
  titleAfterStyle,
  titleStyle,
  wrapperStyle
} from './styles.ts';

type InputContentProps = {
  title?: string;
  titleAfter?: string;
  footer?: string;
  style?: CSSProperties;
  styleTitle?: CSSProperties;
  children: ReactNode;
};

export const InputContent = ({
  title,
  titleAfter,
  footer,
  style,
  styleTitle,
  children
}: InputContentProps) => {
  return (
    <div style={{ ...wrapperStyle, ...style }}>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        {title && <div style={{ ...titleStyle, ...styleTitle }}>{title}</div>}
        {titleAfter && <div style={titleAfterStyle}>{titleAfter}</div>}{' '}
        {/* Add titleAfter */}
      </div>
      {children}
      {footer && <div style={footerStyle}>{footer}</div>}
    </div>
  );
};
